export default __webpack_public_path__ + "static/media/illustration-work-anywhere.ca73b1b2.svg";